import { Component, Input, Output, EventEmitter } from '@angular/core'
import { inIFrame } from './utils'

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Output() outsideClick = new EventEmitter();
  @Output() close: EventEmitter<null> = new EventEmitter<null>();
  @Input() removeVisible = true;
  @Input() width = 500;
  @Input() shade = true;
  www: boolean
  private _sideNavZIndex: number;

  ngOnInit(): void {
    this.www = inIFrame()
    const sideNav = document.getElementById('mat-sidenav')
    if (sideNav) {
      this._sideNavZIndex = sideNav.style['z-index'] || 6
      sideNav.style['z-index'] = 0
    }
  }

  resetSidenavZIndex(): void {
    if (this._sideNavZIndex && document.getElementById('mat-sidenav')) {
      document.getElementById('mat-sidenav').style['z-index'] = this._sideNavZIndex
    }
  }

  ngOnDestroy(): void {
    this.resetSidenavZIndex()
  }

  shadeClicked() {
    this.outsideClick.emit()
  }

  shadeClickedIf(e: MouseEvent): void {
    if ( (<HTMLElement>e.target).classList.contains('modal-stuff') ) {
      this.outsideClick.emit()
    }
  }

  preventDrag(event) {
    event.stopPropagation()
  }

  shadeStyle() {
    if (!this.shade) {
      return {'background-color': 'transparent'}
    }
  }
}
